import type { components } from "@/api-schema";
import { DepartmentIdentifierSystem } from "@/api-schema-enums";
import { normalizePositiveSafeIntegerIdentifier } from "@/common/helpers/normalize-numeric-identifier";

type Department = Pick<components["schemas"]["Department"], "departmentIdentifiers">;
type DepartmentIdentifierDto = components["schemas"]["DepartmentIdentifierDto"];

export function getDepartmentV1Identifier(department: Department): string | undefined {
  return department.departmentIdentifiers?.find((identifier) => identifier.type === DepartmentIdentifierSystem.V1)
    ?.identifier;
}

export function toDepartmentIdentifierDtos(v1Identifier: string): DepartmentIdentifierDto[] {
  const normalizedIdentifier = normalizePositiveSafeIntegerIdentifier(v1Identifier);
  return normalizedIdentifier === undefined
    ? []
    : [{ type: DepartmentIdentifierSystem.V1, identifier: normalizedIdentifier }];
}
